import { useEffect, useRef, useState } from 'react'

// Off screen but laid out at a fixed desktop-like size, so the HUD copy matches
// the desktop panel and the bridge can map ray hits to real element rectangles.
const offscreen = { position: 'fixed', left: -10000, top: -10000, width: 1280, height: 4000, pointerEvents: 'none' }

export function useXRSession(world) {
  const [session, setSession] = useState(() => world.xr?.session || null)
  useEffect(() => {
    const onSession = value => setSession(value || null)
    world.on('xrSession', onSession)
    setSession(world.xr?.session || null)
    return () => world.off('xrSession', onSession)
  }, [world])
  return session
}

/**
 * Renders `children` normally outside XR. During an immersive session the same
 * elements are kept off screen and shown in the world-anchored XR panel through the
 * HTML bridge, clickable with the controller ray. `placement` must be stable.
 */
export function XRHudSurface({ world, placement, children }) {
  const session = useXRSession(world)
  const ref = useRef(null)
  useEffect(() => {
    const bridge = world.pointer?.xrHtml
    if (!session || !bridge || !ref.current) return
    return bridge.attach(ref.current, placement)
  }, [world, session, placement])
  if (!session) return children
  return (
    <div ref={ref} style={offscreen}>
      {children}
    </div>
  )
}
